// Data from Building Bridges Analysis (2021-2025)
export const programData = {
  visitTrends: [
    { year: '2021', totalVisits: 22732, adhdDiagnoses: 411, adhdPercentage: 2.0, adhdVisits: 1782 },
    { year: '2022', totalVisits: 24558, adhdDiagnoses: 478, adhdPercentage: 2.0, adhdVisits: 1956 },
    { year: '2023', totalVisits: 26142, adhdDiagnoses: 566, adhdPercentage: 2.0, adhdVisits: 2435 },
    { year: '2024', totalVisits: 29523, adhdDiagnoses: 638, adhdPercentage: 2.0, adhdVisits: 2572 },
    { year: '2025*', totalVisits: 19411, adhdDiagnoses: 277, adhdPercentage: 1.0, adhdVisits: 1290 }
  ],
  
  payorMix: [
    { name: 'Medicaid', value: 7344, percentage: 73.2, color: '#FF6B6B' },
    { name: 'Commercial', value: 2477, percentage: 24.7, color: '#4ECDC4' },
    { name: 'Self-Pay', value: 214, percentage: 2.1, color: '#FECA57' }
  ],
  
  comorbidityData: [
    { condition: 'ADHD Only', patients: 3145, category: 'Single' },
    { condition: 'Anxiety Only', patients: 1703, category: 'Single' },
    { condition: 'Depression Only', patients: 470, category: 'Single' },
    { condition: 'ADHD + Anxiety', patients: 521, category: 'Dual' },
    { condition: 'ADHD + Depression', patients: 116, category: 'Dual' },
    { condition: 'Anxiety + Depression', patients: 533, category: 'Dual' },
    { condition: 'ADHD + Anxiety + Depression', patients: 209, category: 'Triple' }
  ],
  
  telehealthTrends: [
    { year: '2021', telehealth: 1534, office: 56017, telehealthPercent: 2.7 },
    { year: '2022', telehealth: 1654, office: 63958, telehealthPercent: 2.5 },
    { year: '2023', telehealth: 2049, office: 67933, telehealthPercent: 2.9 },
    { year: '2024', telehealth: 2181, office: 74479, telehealthPercent: 2.8 },
    { year: '2025*', telehealth: 1127, office: 36199, telehealthPercent: 3.0 }
  ],
  
  keyMetrics: {
    totalPatients: 122366,
    providerScope: "Dr. Anzalone's practice data only",
    adhdDiagnoses: 2370,
    avgADHDRate: 1.8,
    medicaidDominance: 73.2,
    comorbidityRate: 21.2,
    telehealthGrowth: 42.2,
    visitGrowth: 44.3
  }
};

// Data gaps identified in analysis
export const dataGaps = {
  highPriority: [
    'Annual anxiety diagnosis trends',
    'Depression visit volumes by year',
    'Outcomes measurement data',
    'Sociodemographic breakdowns'
  ],
  mediumPriority: [
    'Payor mix for non-ADHD conditions',
    'Telehealth by diagnosis type',
    'Treatment completion rates'
  ]
};

// Strategic recommendations
export const recommendations = [
  {
    title: 'Prioritize Medicaid Partnerships',
    priority: 'HIGH',
    timeline: '6-12 months',
    impact: 'Sustainable funding for 7,344+ patients',
    actions: [
      'Develop Medicaid-specific ADHD care pathways',
      'Advocate for enhanced behavioral health reimbursement rates',
      'Pursue Medicaid waiver programs for integrated care',
      'Create cost-effectiveness studies for Medicaid decision-makers'
    ]
  },
  {
    title: 'Expand Integrated Behavioral Health Screening',
    priority: 'HIGH',
    timeline: '3-6 months',
    impact: 'Improved outcomes for 1,379+ comorbid patients',
    actions: [
      'Implement universal mental health screening protocols',
      'Train providers in multi-diagnosis management',
      'Develop care coordination systems',
      'Create referral pathways for complex cases'
    ]
  },
  {
    title: 'Strengthen Telehealth Infrastructure',
    priority: 'MEDIUM',
    timeline: '6-9 months',
    impact: 'Enhanced access for underserved populations',
    actions: [
      'Optimize telehealth platforms for ADHD follow-ups',
      'Expand rural and underserved area coverage',
      'Develop telehealth protocols for behavioral health',
      'Train staff in virtual care delivery'
    ]
  },
  {
    title: 'Investigate 2025 Diagnostic Trends',
    priority: 'HIGH',
    timeline: 'Immediate',
    impact: 'Prevent potential underdiagnosis of 100+ cases annually',
    actions: [
      'Analyze seasonal vs systemic factors',
      'Review diagnostic capacity and training',
      'Assess COVID-19 lingering effects',
      'Monitor monthly trends through 2025'
    ]
  }
];
